import { render } from "./saldos.vue?vue&type=template&id=51a62bca&scoped=true"
import script from "./saldos.vue?vue&type=script&lang=js"
export * from "./saldos.vue?vue&type=script&lang=js"

import "./saldos.vue?vue&type=style&index=0&id=51a62bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a62bca"]])

export default __exports__